import {Avatar} from '@mui/material';
import {getInitials} from '../../../utils/utils';
import './ArrAvatar.scss';

interface ArrAvatarProps {
  name: string;
  className?: string;
  size?: number;
  dataTestId: string;
}

const COLOR_GROUPS: Record<string, string[]> = {
  '#9F75DF': ['A', 'M', 'Y'],
  '#29D8E1': ['B', 'N', 'Z'],
  '#2DCB92': ['C', 'O'],
  '#D0DB57': ['D', 'P'],
  '#FF9E2C': ['E', 'Q'],
  '#6E87FF': ['F', 'R'],
  '#C4AAEB': ['G', 'S'],
  '#7AE7EC': ['H', 'T'],
  '#7DDFBB': ['I', 'U'],
  '#E2E997': ['J', 'V'],
  '#FFC37D': ['K', 'W'],
  '#A5C1FF': ['L', 'X'],
};

const DEFAULT_COLOR = '#2DCB92';

export const getAvatarColor = (name: string): string => {
  const firstChar = name?.trim()?.charAt(0)?.toUpperCase();

  if (!firstChar || !/[A-Z]/.test(firstChar)) return DEFAULT_COLOR;

  for (const [color, letters] of Object.entries(COLOR_GROUPS)) {
    if (letters.includes(firstChar)) return color;
  }

  return DEFAULT_COLOR;
};

const ArrAvatar: React.FC<ArrAvatarProps> = ({
  name,
  size = 2, // default 2rem
  className = '',
  dataTestId,
}) => {
  const color = getAvatarColor(name);

  return (
    <Avatar
      className={`arr-avatar ${className}`}
      style={
        {
          '--arr-avatar-size': `${size}rem`,
          backgroundColor: color,
        } as React.CSSProperties
      }
      data-testid={dataTestId}
    >
      {getInitials(name)}
    </Avatar>
  );
};

export default ArrAvatar;
